import { createFeatureSelector, createSelector } from "@ngrx/store";
import type { BugReportState } from "./bug-report.models";

export const selectBugReportState = createFeatureSelector<BugReportState>('bugReport');

export const selectBugReportSubmitting = createSelector(
  selectBugReportState,
  (state) => state.submitting
);

export const selectBugReportsLoading = createSelector(
  selectBugReportState,
  (state) => state.loading
);

export const selectBugReportError = createSelector(
  selectBugReportState,
  (state) => state.error
);

export const selectBugReportSuccess = createSelector(
  selectBugReportState,
  (state) => state.success
);

export const selectLastBugReport = createSelector(
  selectBugReportState,
  (state) => state.lastSubmitted
);

export const selectBugReports = createSelector(
  selectBugReportState,
  (state) => state.reports
);
